import React, { useState } from "react";
import "./Footer.css";
import { t } from "@lingui/macro";

const Footer = ({ showModal }) => {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  return (
    <>
      {/* Przycisk Contact na mobile */}
      <button
        className="contact-toggle-btn"
        onClick={() => setIsFooterVisible(!isFooterVisible)}
      >
        {isFooterVisible ? t`Close` : t`Contact`}
      </button>

      {/* Stopka wyświetlana tylko po kliknięciu */}
      <footer
        className={`nav-footer-common ${
          isFooterVisible ? "footer-visible" : ""
        }`}
      >
        <div className="footer-contact">
          <h3>{t`Contact Us`}</h3>
          <p>{t`Carr. Huichapan - Tecozautla Km. 27.5`}</p>
          <p>{t`Morelos, 42440 Tecozautla, Hgo. Mexico`}</p>
          <p>{t`WhatsApp:`} 7711949533</p>
          <p>{t`Hotel:`} 7731068780</p>
          <p>{t`Email:`} ventas@arenalacuatico.com</p>
        </div>

        <div className="footer-buttons">
          <button onClick={() => showModal("map")}>
            {t`Find Us Here`}
          </button>
        </div>

        <hr />

        <div className="footer-bottom">
          ©{new Date().getFullYear()} {t`Balneario El Arenal. All rights reserved.`}
          <p>{t`Monika Gudalewska : StormSister`}</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
